"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.split.js");
require("core-js/modules/es.object.get-prototype-of.js");
var _react = _interopRequireDefault(require("react"));
var _semanticUiReact = require("semantic-ui-react");
var _Header = _interopRequireDefault(require("./Header"));
var _Footer = _interopRequireDefault(require("./Footer"));
var _HeaderCell = _interopRequireDefault(require("./HeaderCell"));
var _Row = _interopRequireDefault(require("./Row"));
var _DividerRow = _interopRequireDefault(require("./DividerRow"));
var _Body = _interopRequireDefault(require("./Body"));
var _cellTypes = _interopRequireDefault(require("./cellTypes"));
var _lodash = _interopRequireDefault(require("lodash"));
var _utils = require("../../../../../common/utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var FemaGoTable = /*#__PURE__*/function (_React$Component) {
  _inherits(FemaGoTable, _React$Component);
  var _super = _createSuper(FemaGoTable);
  function FemaGoTable() {
    var _this;
    _classCallCheck(this, FemaGoTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.handleTableType = function () {
      var _React$createElement;
      var _this$props = _this.props,
        name = _this$props.name,
        type = _this$props.type,
        summary = _this$props.summary,
        scrollable = _this$props.scrollable,
        collapsing = _this$props.collapsing,
        children = _this$props.children,
        columns = _this$props.columns,
        className = _this$props.className,
        basic = _this$props.basic,
        celled = _this$props.celled;
      var cell;
      var formatedName;
      var addName = ' FEMA GO Data Table';
      if (_lodash.default.indexOf(name, '.') > 0) {
        formatedName = _lodash.default.upperFirst(_lodash.default.lowerCase(_lodash.default.split(name, '.')[1])) + addName;
      } else {
        formatedName = name;
      }
      switch (type) {
        case 'entry':
          cell = /*#__PURE__*/_react.default.createElement(_semanticUiReact.Table, {
            name: name,
            celled: celled === undefined ? true : celled,
            collapsing: collapsing,
            className: "entryTable",
            summary: summary || formatedName || 'FEMA GO data table',
            columns: columns,
            basic: basic,
            style: {
              width: scrollable ? scrollable + '%' : ''
            }
          }, children);
          break;
        case 'static':
          cell = /*#__PURE__*/_react.default.createElement(_semanticUiReact.Table, (_React$createElement = {
            name: name,
            basic: true,
            collapsing: collapsing,
            className: className || 'staticTable',
            summary: summary || formatedName || 'FEMA GO data table',
            columns: columns
          }, _defineProperty(_React$createElement, "basic", basic), _defineProperty(_React$createElement, "style", {
            width: scrollable ? scrollable + '%' : ''
          }), _React$createElement), children);
          break;
        default:
          cell = /*#__PURE__*/_react.default.createElement(_semanticUiReact.Table, {
            summary: summary || undefined
          }, children);
      }
      return cell;
    };
    return _this;
  }
  _createClass(FemaGoTable, [{
    key: "render",
    value: function render() {
      var withForm = this.props.withForm;
      return withForm === false ? this.handleTableType() : /*#__PURE__*/_react.default.createElement(_semanticUiReact.Form, {
        className: "tableForm",
        onSubmit: this.props.handleSubmit
      }, this.handleTableType());
    }
  }]);
  return FemaGoTable;
}(_react.default.Component);
var DollarCell = _cellTypes.default.DollarCell,
  SelectCell = _cellTypes.default.SelectCell,
  TextAreaCell = _cellTypes.default.TextAreaCell,
  InputCell = _cellTypes.default.InputCell,
  NumberCell = _cellTypes.default.NumberCell,
  TextCell = _cellTypes.default.TextCell,
  PercentCell = _cellTypes.default.PercentCell,
  DateCell = _cellTypes.default.DateCell,
  CheckboxCell = _cellTypes.default.CheckboxCell,
  RadioCell = _cellTypes.default.RadioCell,
  DeleteCell = _cellTypes.default.DeleteCell,
  SelectWithCommentCell = _cellTypes.default.SelectWithCommentCell,
  ActionCell = _cellTypes.default.ActionCell,
  StatusCell = _cellTypes.default.StatusCell;
FemaGoTable.SelectWithCommentCell = SelectWithCommentCell;
FemaGoTable.Header = _Header.default;
FemaGoTable.Footer = _Footer.default;
FemaGoTable.HeaderCell = _HeaderCell.default;
FemaGoTable.Body = _Body.default;
FemaGoTable.DollarCell = DollarCell;
FemaGoTable.DollarCellEnhanced = (0, _utils.enhance)(DollarCell);
FemaGoTable.SelectCell = SelectCell;
FemaGoTable.TextAreaCell = TextAreaCell;
FemaGoTable.TextAreaCellEnhanced = (0, _utils.enhance)(TextAreaCell);
FemaGoTable.InputCell = InputCell;
FemaGoTable.NumberCell = NumberCell;
FemaGoTable.TextCell = TextCell;
FemaGoTable.PercentCell = PercentCell;
FemaGoTable.DateCell = DateCell;
FemaGoTable.DeleteCell = DeleteCell;
FemaGoTable.Row = _Row.default;
FemaGoTable.DividerRow = _DividerRow.default;
FemaGoTable.CheckboxCell = CheckboxCell;
FemaGoTable.RadioCell = RadioCell;
FemaGoTable.ActionCell = ActionCell;
FemaGoTable.StatusCell = StatusCell;
var _default = FemaGoTable;
exports.default = _default;